import { useState } from 'react';

import { toast } from '../components/Toaster';

type CopiedValue = string | null;

type CopyFn = (text: string) => Promise<boolean>;

export const useClipboard = () => {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const toaster = () => {
    toast('Copied!', {
      closeButton: true,
      duration: 1000,
      position: 'bottom-center',
    });
  };

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported');

      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      toaster();

      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);

      return false;
    }
  };

  return { copiedText, copy };
};
